// @flow
import { RESORT_SPACE_INTRODUCTION } from 'Client/cms/toolkit/constants';
import gqlClient from 'Utils/graphql-client/graphqlClient';
import { LINE_PRODUCT_SPACE_INTRODUCTION } from 'Utils/request/requestDictionary';

export const productSpaceIntroductionResolver = {
  name: RESORT_SPACE_INTRODUCTION,
  resolve(appContext: AppContext) {
    const query = `query {
      config {
        common {
          viewMore
          loadLess
        }
      }
    }`;

    return gqlClient.runQuery(query, appContext, {
      requestName: LINE_PRODUCT_SPACE_INTRODUCTION,
      strictErrors: false,
    });
  },
};
